(() => {
  const initializeOffers = () => {
  const offerRoots = document.querySelectorAll('[data-womans-heart-offer]');

  offerRoots.forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const primaryForm = root.querySelector('#lmcd-womans-heart-primary-form');
    const stickyCta = root.querySelector('[data-sticky-cta]');
    const stickyPurchase = root.querySelector('[data-sticky-purchase]');
    const faqTriggers = root.querySelectorAll('[data-faq-trigger]');
    const countdown = root.querySelector('[data-countdown]');
    const menuTrigger = root.querySelector('[data-womans-heart-menu-trigger]');
    const mobileMenu = root.querySelector('[data-womans-heart-mobile-menu]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (menuTrigger && mobileMenu) {
      const setMenuOpen = (open) => {
        mobileMenu.hidden = !open;
        menuTrigger.setAttribute('aria-expanded', String(open));
        menuTrigger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      };
      menuTrigger.addEventListener('click', (event) => {
        event.stopPropagation();
        setMenuOpen(menuTrigger.getAttribute('aria-expanded') !== 'true');
      });
      mobileMenu.querySelectorAll?.('a').forEach((link) => link.addEventListener('click', () => setMenuOpen(false)));
      document.addEventListener?.('keydown', (event) => {
        if (event.key === 'Escape') setMenuOpen(false);
      });
      document.addEventListener?.('click', (event) => {
        if (menuTrigger.getAttribute('aria-expanded') === 'true' && !menuTrigger.contains(event.target) && !mobileMenu.contains(event.target)) setMenuOpen(false);
      });
    }
    const photos = root.querySelector('.lmcd-womans-heart__proof-images');
    if (photos && !reducedMotion) {
      // Three identical sets; the source advances one photo every four seconds.
      photos.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-' + photos.scrollWidth / 3 + 'px)' }], { duration: 16000, iterations: Infinity, easing: 'linear' });
    }

    if (stickyCta) {
      const wrapper = root.closest?.('.page-wrapper');
      const updateSticky = () => {
        const wrapperScrolls = wrapper && ['auto', 'scroll'].includes(window.getComputedStyle(wrapper).overflowY);
        const bounds = primaryForm?.getBoundingClientRect();
        const scrollTop = wrapperScrolls ? wrapper.scrollTop : window.scrollY;
        const viewportHeight = wrapperScrolls ? wrapper.clientHeight : window.innerHeight;
        const contentHeight = wrapperScrolls ? wrapper.scrollHeight : document.documentElement.scrollHeight;
        const nearBottom = scrollTop + viewportHeight >= contentHeight - 100;
        const pastOffer = window.innerWidth >= 768 ? scrollTop > 900 : bounds && bounds.bottom <= 0;
        stickyCta.hidden = !bounds || !pastOffer || nearBottom;
      };
      updateSticky();
      wrapper?.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
    }

    root.querySelectorAll('a[href^="#lmcd-womans-heart-"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    root.querySelectorAll('[data-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-carousel-track]');
      if (!track) return;
      const move = (direction) => track.scrollBy({ left: direction * (track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0)), behavior: reducedMotion ? 'auto' : 'smooth' });
      carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => move(-1));
      carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => move(1));
      track.addEventListener('keydown', (event) => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
    });

    const videoSoundControls = Array.from(root.querySelectorAll('[data-shopify-video]')).map((container) => ({
      video: container.querySelector('video'),
      toggle: container.querySelector('[data-video-sound-toggle]')
    })).filter(({ video, toggle }) => video && toggle);
    const syncSoundControl = ({ video, toggle }) => {
      const soundOn = !video.muted;
      toggle.setAttribute('aria-pressed', String(soundOn));
      toggle.setAttribute('aria-label', soundOn ? 'Turn sound off' : 'Turn sound on');
      const soundOffIcon = toggle.querySelector('[data-sound-off]');
      const soundOnIcon = toggle.querySelector('[data-sound-on]');
      if (soundOffIcon) soundOffIcon.hidden = soundOn;
      if (soundOnIcon) soundOnIcon.hidden = !soundOn;
    };
    videoSoundControls.forEach((control) => {
      const { video, toggle } = control;
      syncSoundControl(control);
      video.addEventListener('volumechange', () => syncSoundControl(control));
      toggle.addEventListener('click', (event) => {
        event.stopPropagation();
        const turnSoundOn = video.muted;
        if (turnSoundOn) {
          videoSoundControls.forEach((other) => {
            if (other !== control) {
              other.video.muted = true;
              syncSoundControl(other);
            }
          });
          video.muted = false;
          const playback = video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(() => {});
        } else {
          video.muted = true;
        }
        syncSoundControl(control);
      });
    });

    faqTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const panelId = trigger.getAttribute('aria-controls');
        const panel = panelId ? root.querySelector('#' + panelId) : null;
        const expanded = trigger.getAttribute('aria-expanded') === 'true';

        trigger.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.hidden = expanded;
      });
    });

    root.querySelectorAll('[data-footer-trigger]').forEach((trigger) => {
      const panel = root.querySelector('#' + trigger.getAttribute('aria-controls'));
      if (!panel) return;
      let mobile;
      const updateFooter = () => {
        const nextMobile = window.innerWidth < 768;
        if (nextMobile === mobile) return;
        mobile = nextMobile;
        panel.hidden = mobile;
        trigger.setAttribute('aria-expanded', String(!mobile));
      };
      trigger.addEventListener('click', () => {
        if (!mobile) return;
        panel.hidden = !panel.hidden;
        trigger.setAttribute('aria-expanded', String(!panel.hidden));
      });
      updateFooter();
      window.addEventListener('resize', updateFooter);
    });

    if (stickyPurchase && primaryForm && !stickyPurchase.disabled) {
      stickyPurchase.addEventListener('click', () => {
        if (typeof primaryForm.requestSubmit === 'function') {
          primaryForm.requestSubmit();
        } else {
          primaryForm.querySelector('[type="submit"]')?.click();
        }
      });
    }

    if (countdown) {
      let secondsRemaining = 15 * 60;
      window.setInterval(() => {
        secondsRemaining = Math.max(secondsRemaining - 1, 0);
        const minutes = Math.floor(secondsRemaining / 60);
        const seconds = String(secondsRemaining % 60).padStart(2, '0');
        countdown.textContent = minutes + ':' + seconds;
      }, 1000);
    }
  });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeOffers, { once: true });
  } else {
    initializeOffers();
  }
})();
